<template>
  <div>
    <table v-if="offices.length > 0" class="table">
      <thead>
      <tr>
        <th>Naam</th>
        <th class="compact text-center">Eigenaren</th>
        <th class="compact text-center">Werknemers</th>
        <th class="compact text-center">Relaties</th>
        <th class="compact"></th>
      </tr>
      </thead>

      <tbody>
      <template v-for="office in offices">
        <row-component :key="office.id"
                       :id="office.id"
                       @toggleShowOfficeInfo="toggleShowOfficeInfo(office.id)"
                       @deleted="onDelete"/>
        <tr v-if="showOfficeInfo.includes(office.id)">
          <td colspan="5">
            <dropdown-component :office="office"/>
          </td>
        </tr>
      </template>
      </tbody>
    </table>

    <a-alert v-else message="Deze regio heeft geen kantoren." type="info" :show-icon="true"/>
  </div>
</template>

<script>
import RowComponent from "./RowComponent";
import DropdownComponent from "./DropdownComponent";

export default {
  name: "OfficesTable",
  components: {DropdownComponent, RowComponent},
  props: {
    offices: {
      type: Array,
      require: true,
    }
  },
  data() {
    return {
      showOfficeInfo: [],
    }
  },
  methods: {
    onDelete(officeId) {
      this.$emit('deleted', officeId);
    },
    toggleShowOfficeInfo(id) {
      this.showOfficeInfo.includes(id) ?
          this.showOfficeInfo.splice(this.showOfficeInfo.indexOf(id), 1) :
          this.showOfficeInfo.push(id);
    }
  }
}
</script>

<style scoped>

</style>